export default `<p><strong>إصدار المستند:</strong> V3.28 &nbsp;|&nbsp; <strong>تاريخ الإصدار:</strong> 2022 &nbsp;|&nbsp; <strong>نوع المستند:</strong> ورقة بيضاء للمنتج وملخص تقييم الأمان</p>

<h2>1. الملخص التنفيذي</h2>
<p>وحدة Lending Pool هذه هي خدمة إقراض وسيولة على السلسلة مبنية على بروتوكولات DeFi لسوق النقد. من خلال العقود الذكية مفتوحة المصدر ونماذج الفائدة البرمجية، يربط النظام أصول المستخدمين الرقمية بأسواق الإقراض على السلسلة، مما يتيح <strong>العائد على الودائع، والاقتراض المضمون، ومشاركة السيولة</strong>.</p>
<p>لا تعتمد الوحدة على تدخل يدوي في توزيع الأموال اليومي. يتم تحديد الأسعار والسعة والاستخدام في الوقت الفعلي بواسطة الأسواق على السلسلة وتُعرض بشفافية عبر تجميع البيانات من مصادر متعددة.</p>

<h2>2. خلفية الصناعة وموقع المنتج</h2>
<p>يعتمد الإقراض التقليدي على مؤسسات مركزية. تستخدم بروتوكولات DeFi العقود الذكية لمطابقة العرض والطلب تلقائياً، مع ضمانات زائدة وآليات تصفية.</p>
<p>موقع هذه الوحدة:</p>
<ul>
  <li><strong>بوابة سوق النقد على السلسلة:</strong> تجميع بيانات pools عبر سلاسل وبروتوكولات متعددة؛</li>
  <li><strong>توزيع برمجي للعوائد:</strong> تسوية تلقائية وفق جدول ثابت بناءً على الأرصدة المصرح بها وAPY السوق؛</li>
  <li><strong>شفاف وقابل للتحقق:</strong> TVL وAPY والاستخدام وLTV قابلة للتتبع إلى بيانات على السلسلة؛</li>
  <li><strong>غير حاضنة:</strong> يبدأ التفويض والتفاعلات على السلسلة من محفظة المستخدم.</li>
</ul>

<h2>3. بنية النظام</h2>
<h3>3.1 نظرة عامة</h3>
<ul>
  <li><strong>طبقة واجهة المستخدم:</strong> ربط المحفظة، التفويض، تصفح pools، استعلام الأرباح؛</li>
  <li><strong>طبقة الخدمات:</strong> المصادقة، إدارة التفويض، أوامر العائد، محتوى متعدد اللغات؛</li>
  <li><strong>طبقة تجميع البيانات:</strong> مزامنة مجدولة من مصادر DeFi العامة؛</li>
  <li><strong>طبقة البروتوكول على السلسلة:</strong> عقود إقراض مدققة تنفذ منطق الإيداع والاقتراض.</li>
</ul>

<h3>3.2 المقاييس الأساسية</h3>
<table>
  <thead>
    <tr><th>المقياس</th><th>الوصف</th></tr>
  </thead>
  <tbody>
    <tr><td>TVL</td><td>إجمالي أصول ال pool بالدولار</td></tr>
    <tr><td>Supply APY</td><td>العائد السنوي للودائع</td></tr>
    <tr><td>Borrow APY</td><td>التكلفة السنوية للمقترضين</td></tr>
    <tr><td>معدل الاستخدام</td><td>نسبة الأموال المقترضة إلى المتاحة</td></tr>
    <tr><td>Max LTV</td><td>أقصى نسبة قرض إلى قيمة قبل التصفية</td></tr>
    <tr><td>Supply / Borrow Cap</td><td>حدود لكل أصل للتحكم في تركز المخاطر</td></tr>
    <tr><td>السيولة المتاحة</td><td>سيولة قابلة للاقتراض فوراً</td></tr>
  </tbody>
</table>

<h2>4. مسار المستخدم وآلية العائد</h2>
<ol>
  <li><strong>ربط المحفظة</strong> عبر Web3؛</li>
  <li><strong>تفويض الأصول</strong> (USDT، USDC، إلخ) عبر Approve على السلسلة؛</li>
  <li><strong>الانضمام إلى lending pool</strong> للدخول في قائمة حساب العائد؛</li>
  <li><strong>تسوية العائد</strong> يومياً بناءً على الرصيد المصرح به وأسعار السوق؛</li>
  <li><strong>عرض الأصول</strong> في «محفظتي».</li>
</ol>
<p><strong>APY التاريخي لا يضمن عوائد مستقبلية.</strong></p>

<h3>4.3 الرسوم</h3>
<h4>كيف تُفرض رسوم DeFi Earn؟</h4>
<p>تتطلب المعاملات على السلسلة رسوم gas لإتمام التفاعل مع العقود الذكية، بما في ذلك الاشتراك واستلام العوائد. بالنسبة لبعض الأصول، قد يفرض lending pool DeFi ومديرو vault رسوم أداء كنسبة من أرباحك الفعلية؛ لا يتأثر رأس المال.</p>

<h2>5. تصميم الأمان</h2>
<ul>
  <li>بروتوكولات أساسية بعقود مفتوحة المصدر ومدققة؛</li>
  <li>بنية غير حاضنة؛ لا تخزين للمفاتيح الخاصة؛</li>
  <li>أقل صلاحيات Token Approve؛ قابلة للإلغاء في أي وقت؛</li>
  <li>مصادقة token، HTTPS، RBAC إدارية، وسجلات تدقيق.</li>
</ul>

<h2>6. ملخص تقييم الأمان</h2>
<table>
  <thead>
    <tr><th>البند</th><th>النتيجة</th><th>ملاحظات</th></tr>
  </thead>
  <tbody>
    <tr><td>اعتماديات العقود الذكية</td><td><strong>ناجح</strong></td><td>بروتوكولات DeFi مدققة علناً</td></tr>
    <tr><td>غير حاضنة وإدارة المفاتيح</td><td><strong>ناجح</strong></td><td>لا تخزين للمفاتيح الخاصة</td></tr>
    <tr><td>API والمصادقة</td><td><strong>ناجح</strong></td><td>مصادقة token وHTTPS</td></tr>
    <tr><td>مزامنة البيانات</td><td><strong>ناجح</strong></td><td>مزامنة مجدولة مع snapshots</td></tr>
    <tr><td>منطق تسوية العائد</td><td><strong>ناجح</strong></td><td>قواعد واضحة؛ أوامر قابلة للتدقيق</td></tr>
  </tbody>
</table>

<h2>7. الإفصاح عن المخاطر</h2>
<ul>
  <li><strong>مخاطر العقود الذكية:</strong> قد توجد ثغرات غير مكتشفة؛</li>
  <li><strong>مخاطر السوق:</strong> APY قد يتقلب بشكل كبير؛</li>
  <li><strong>مخاطر التصفية:</strong> انخفاض حاد في الضمان قد يؤدي إلى التصفية؛</li>
  <li><strong>مخاطر فك ربط stablecoin:</strong> USDT/USDC قد تنحرف عن 1.00$؛</li>
  <li><strong>مخاطر تنظيمية:</strong> تنظيم DeFi لا يزال يتطور عالمياً.</li>
</ul>
<p><strong>لا توفر هذه الوحدة نصيحة استثمارية ولا تضمن عوائد ثابتة.</strong></p>

<h2>8. مسرد المصطلحات</h2>
<ul>
  <li><strong>APY:</strong> العائد السنوي؛</li>
  <li><strong>TVL:</strong> إجمالي القيمة المقفلة؛</li>
  <li><strong>LTV:</strong> نسبة القرض إلى القيمة؛</li>
  <li><strong>Approve:</strong> تفويض token ERC-20؛</li>
  <li><strong>التصفية (Liquidation):</strong> بيع تلقائي للضمان عند نقصه.</li>
</ul>

<p>— لأغراض إعلامية فقط. لا يُعد نصيحة قانونية أو مالية أو استثمارية. تحقق من البيانات على السلسلة عبر مستكشفات الكتل والواجهات الرسمية للبروتوكولات.</p>`
